import React, { useEffect, useState } from 'react';
import { AutoComplete, Spin } from 'antd';
import FiltersService from '../../services/FiltersService';

interface CityAutoCompleteProps {
  value: string;
  onChange: (value: string, option?: { label: string, value: string }) => void;
  stateCode: string;
  error?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  onSelect?: (value: string, option: { label: string, value: string }) => void;
  size?: 'small' | 'middle' | 'large';
}

const CityAutoComplete: React.FC<CityAutoCompleteProps> = ({
  value,
  onChange,
  stateCode,
  error,
  placeholder = 'City *',
  disabled = false,
  className = '',
  onSelect,
  size = 'large'
}) => {
  const [options, setOptions] = useState<{ label: string, value: string }[]>([]);
  const [loading, setLoading] = useState(false);
  const [displayValue, setDisplayValue] = useState<string>('');

  useEffect(() => {
    if (!stateCode) {
      setOptions([]);
      setDisplayValue('');
      return;
    }
    setLoading(true);
    FiltersService.getCitiesByStateCode(stateCode)
      .then(cities => {
        const mapped = cities.map(city => ({ label: city.cityName, value: city.cityCode }));
        console.log('CityAutoComplete stateCode:', stateCode, 'city options:', mapped);
        setOptions(mapped);

        // Find the city name for the current value (if it's a city code)
        if (value) {
          const selectedCity = mapped.find(city => city.value === value);
          if (selectedCity) {
            setDisplayValue(selectedCity.label);
          } else {
            setDisplayValue(value);
          }
        } else {
          setDisplayValue('');
        }
      })
      .catch(() => setOptions([]))
      .finally(() => setLoading(false));
  }, [stateCode, value]);

  return (
    <div
      className="custom-autocomplete-wrapper"
      tabIndex={-1}
    >
      <AutoComplete
        className={className + (error ? ' is-invalid' : '')}
        placeholder={placeholder}
        value={displayValue}
        options={options}
        disabled={disabled || !stateCode}
        size={size}
        bordered={true}
        filterOption={(inputValue, option) =>
          option && option.label && typeof option.label === 'string'
            ? option.label.toLowerCase().includes(inputValue.toLowerCase())
            : false
        }
        onSelect={(value, option) => {
          const selectedOption = option as { label: string, value: string };
          setDisplayValue(selectedOption.label);
          if (onSelect) onSelect(selectedOption.value, selectedOption);
          onChange(selectedOption.value, selectedOption);
        }}
        onChange={(inputValue) => {
          setDisplayValue(inputValue);
          // If user is typing, clear the value to indicate no selection
          onChange('', undefined);
        }}
        notFoundContent={loading ? <Spin size="small" /> : null}
        allowClear
      />
    </div>
  );
};

export default CityAutoComplete; 